import { FetchMethod } from '../../models/api/fetch-method'
import { useApiClient } from './useApiClient'
import type { MaybeRef } from 'vue'
import { toValue } from 'vue'

export default function usePut<TOutput, TBody = unknown>(
  endpoint: MaybeRef<string>,
  omitOrganization: boolean = false,
) {
  const { data, status, error, execute } = useApiClient<TOutput, TBody>()

  const mutate = async (body: TBody) => {
    await execute({
      method: FetchMethod.PUT,
      endpoint: toValue(endpoint),
      omitOrganization,
      body,
    })
  }

  return { data, status, error, mutate }
}
